import script from "./ContentReactions.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentReactions.vue?vue&type=script&setup=true&lang=js"

import "./ContentReactions.vue?vue&type=style&index=0&id=1c2d0dad&lang=scss"

const __exports__ = script;

export default __exports__